// extracted by mini-css-extract-plugin
export default {"drawerHeader":"ApprovalSettlementDateQueue_drawerHeader__YNpHt","drawerFooter":"ApprovalSettlementDateQueue_drawerFooter__GUFaH"};